import React, { useState, useEffect, useRef } from 'react';
import './Typeahead.scss';

const TypeaheadDropdown = ({ options, onChange, placeholder, selected, focusChanged, disabled }) => {
  const [query, setQuery] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [displayOptions, setDisplayOptions] = useState(options);
  const inputRef = useRef(null);

  useEffect(() => {
    if (selected && selected.length > 0) {
      setQuery(selected[0]);
    } else {
      setQuery('');
    }
    setDisplayOptions(options);
  }, [selected, options]);

  const handleInputChange = (e) => {
    const newQuery = e.target.value;
    setQuery(newQuery);
    setDisplayOptions(options.filter(option => option.label.toLowerCase().includes(newQuery.toLowerCase())));
    setIsDropdownOpen(true);
  };

  const handleOptionClick = (option) => {
    setQuery(option.label);
    setIsDropdownOpen(false);
    onChange([option.label]);
    inputRef.current.blur();
  };

  const handleInputFocus = () => {
    setIsDropdownOpen(true);
    focusChanged(true, 'countyFilter');
    setDisplayOptions(options);
  };

  const handleInputBlur = () => {
    setIsDropdownOpen(false);
    focusChanged(false, '');
  };

  return (
    <div className="typeahead-container">
      <input
        className={`form-control ${query ? 'user-typed' : ''}`}
        type="text"
        value={query}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        placeholder={placeholder}
        disabled={disabled}
        ref={inputRef}
      />
      {isDropdownOpen && (
        <div className="typeahead-dropdown-container">
          <ul className="typeahead-dropdown">
            {displayOptions.length > 0 ? (
              displayOptions.map((option) => (
                <li
                  key={option.label}
                  className="list-group-item"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleOptionClick(option);
                  }}
                >
                  {option.label}
                </li>
              ))
            ) : (
              <li className="list-group-item no-suggestions">No matching suggestions</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TypeaheadDropdown;
